import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="w-full bg-[#1a0000] py-10 sm:py-14 px-4" data-id="element-205">
      <div className="max-w-2xl mx-auto text-center" data-id="element-206">
        <h2 className="text-xl sm:text-3xl font-black text-white mb-5" data-id="element-207">
          ⏰ PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className="mb-4" data-id="element-208">
          <CountdownTimer size="lg" blinking={true} data-id="element-209" />
        </div>

        <p className="text-white text-base sm:text-lg font-bold mb-6" data-id="element-210">
          Después sube{' '}
          <span className="text-[#FF0000] font-black" data-id="element-211">$10.000</span> y no vuelve
          a bajar.
        </p>

        {/* Progress bar */}
        <div className="max-w-md mx-auto" data-id="element-212">
          <div className="flex items-center justify-between mb-1.5" data-id="element-213">
            <span className="text-[#FF0000] font-bold text-xs sm:text-sm" data-id="element-214">
              🔴 Cupos limitados
            </span>
            <span className="text-white text-xs sm:text-sm font-bold" data-id="element-215">
              Quedan pocos
            </span>
          </div>
          <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden" data-id="element-216">
            <div className="h-full rounded-full bg-gradient-to-r from-[#FF0000] to-[#FF6600]" style={{
            width: '68%'
          }} data-id="element-217" />
          </div>
        </div>
      </div>
    </section>;
}